//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    article: {},
  },
  data() {
    return {
      productTypes: [
        { value: 0, label: this.$t("products.notSelected") },
        { value: 1, label: this.$t("products.stockProduct") },
        { value: 2, label: this.$t("products.timeProduct") },
        { value: 3, label: this.$t("products.somethingElse") },
      ],
      dense: true,
    };
  },
  methods: {},
};
